'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIELD_META_PROP = exports.FIELD_META_PROP = 'data-__meta';


//////////////////
// WEBPACK FOOTER
// ./~/.2.9.0@antd/lib/form/constants.js
// module id = 187
// module chunks = 0